import { WarningOutlined } from "@ant-design/icons";
import { Trans } from "@lingui/macro";
import { Col, Row } from "antd";
import React from "react";

export function GenericNotAllowedPage({icon, message}) {
    // const { accessKeys } = props;
    return (
        <Row align="middle">
            <Col span={24} align="center">
                <p>{icon ?? <WarningOutlined />}</p>
                <h2>{message ?? <Trans>No Permission to Page</Trans>}</h2>
            </Col>
        </Row>
    );
}
